import React from "react";
import useStyles from "../styles/styles";
import cols from "../assets/img/Col.svg";
import appstore from "../assets/img/Button.svg";
import playstore from "../assets/img/Button (1).svg";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { handleAppStoreClick } from "../common/appStoreUtils";

const Availability = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const settings = useSelector((state) => state.settingsdata.settings);

  return (
    <div className={classes.allavailabilityContainer}>
      <div className={classes.spacings}>
        <div className={classes.availabilityContainer}>
          <div>
            <h2 className={classes.h2AvailabilityContainer}>
              {t("onIosAndAndriod")}
            </h2>

            <p className={classes.pAvailabilityContainer}>
              {t("HarakaHasYouCovered")}
            </p>

            <button
              className={`${classes.buttonSectionContainer} ${classes.primaryBtn}`}
              style={{ marginBottom: "24px", marginTop: "16px" }}
              onClick={handleAppStoreClick(
                settings,
                "/login?signup=rider",
                "driver"
              )}
            >
              {t(`downloadRider`)}
            </button>

            <div className={classes.downloadavailabilityBtn}>
              <a
                href="https://apps.apple.com/ng/app/haraka-ride/id6753879505"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={appstore}
                  alt="Download on App Store"
                  style={{ cursor: "pointer" }}
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.harakaride.app"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={playstore}
                  alt="Get it on Google Play"
                  style={{ cursor: "pointer" }}
                />
              </a>
            </div>
          </div>

          <div>
            <img
              src={cols}
              alt="cols"
              className={classes.downloadavailabilityImg}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Availability;
